<template>
  <div :key="listKey">
    <b-row>
      <!-- <b-col cols="3">
        <label class="sa-label-data">Tipologie Documenti Collegati</label>
        <ul v-if="causaleDocumento">
          <li v-for="causale in causaleDocumento.documentiCollegati" :key="causale.id">
            <label :class="{ 'sa-label-data': true, 'ft-active-class': isActiveTipologia(causale), 'sa-badge': true }" @click="onClickTipologiaDocumento(causale)" v-html="getCausaleDocumentoDescrizione(causale)"></label>
          </li></ul
      ></b-col> -->
      <b-col cols="12" class="sa-list-component">
        <div class="sa-list-component-body">
          <div class="b-table-sticky-header">
            <label class="sa-label-data">Documenti Collegati</label>
            <b-table sticky-header ref="table" stacked="xl" striped hover :items="this.jsonData.documentiCollegati" :fields="fields" :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
              <template #cell(index)="row">
                {{ (currentPage - 1) * perPage + row.index + 1 }}
              </template>
              <template #cell(documentoRiferimentoDescrizione)="row">
                <strong>{{ row.item.documentoRiferimentoDescrizione }}</strong>
              </template>
            </b-table>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ContabilitaMixin from "../mixins/ContabilitaMixin";
export default {
  mixins: [ContabilitaMixin],
  computed: {},
  data() {
    return {
      fields: [
        {
          label: "N.",
          key: "index",
          thStyle: "width: 1rem",
        },
        {
          label: "Descrizione Documento Riferimento",
          key: "documentoRiferimentoDescrizione",
          thStyle: "width: 25rem",
        },
      ],
      arraySelezionati: {
        tipiDocumentoSelezionati: [],
      },
      filtro: {
        idTipoDocumenti: [],
        soggettoCognome: null,
        soggettoNome: null,
        soggettoId: null,
      },
      perPage: 10,
      currentPage: 1,
      causaleDocumento: null,
      jsonData: { codiceStruttura: null, documentiCollegati: [] },
      listKey: 0,
      pathResource: "/contabilitadocumenticollegati",
    };
  },
  mounted() {
    console.log(this.jsonData);

    this.contabilitaTipoDocumentoLoadData(this.jsonData.strutturaCodice);
  },
  methods: {
    init(jsonData, causaleDocumento) {
      this.jsonData = jsonData;
      if (jsonData.id) {
        this.loadDataDocumentiCollegati(jsonData.id);
      } else {
        if (causaleDocumento != null) {
          this.causaleDocumento = causaleDocumento;
          this.listKey++;
        }
      }
    },
    isActiveTipologia(causale) {
      return this.arraySelezionati.tipiDocumentoSelezionati.indexOf(causale.id) != -1;
    },
    loadDataDocumentiCollegati(id) {
      console.log("Documenti Collegati: " + id);
    },
    loadDataDocumentiCollegatiSuccess() {},
    loadDataDocumentiCollegatiError() {},
    getCausaleDocumentoDescrizione(causale) {
      console.log(causale);

      let icon = causale.obbligatorio ? '<i style="color:red" size="lg" class="fas fa-exclamation"></i>' : "";

      let span = `${this.getTipoDocumentoDescrizione(causale.idTipoDocumento)} ${icon}`;

      return span;
    },
    onClickTipologiaDocumento(causale) {
      if (this.arraySelezionati.tipiDocumentoSelezionati.indexOf(causale.id) == -1) {
        this.arraySelezionati.tipiDocumentoSelezionati.push(causale.id);
      } else {
        this.arraySelezionati.tipiDocumentoSelezionati.splice(this.arraySelezionati.tipiDocumentoSelezionati.indexOf(causale.id), 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ft-active-class {
  border: 1px solid #36b1cf !important;
}
.sa-badge {
  cursor: pointer;
}
</style>
